<template>
  <div>
    <div class="hred">
      <img id="u51_img" class="img " src="@/images/shenqin/u51.png"/>
      <img id="u52_img" class="img " src="@/images/shenqin/u52.png"/>
    </div>
    <div style="    font-weight: 700;
    font-style: normal;
    font-size: 36px;text-align: center;margin-top: 40px;">机构信息查询</div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <img class="img " src="@/images/biaodan/u113.png">
    </div>
  </div>
  <!-- 表单1 -->
  <el-form ref="form" :model="form" label-width="80px" >
    <el-row>
      <el-col :span="24">
        <el-form-item  label-width="140px"  class="hang" label="机构名称" prop="companyName">
          <el-input class="inputs" v-model="form.companyName" @input="inputnow"/>
          <span class="xing">*</span><span class="bei">请输入备案机构名称</span>
        </el-form-item>
      </el-col>
<!--      <el-col :span="24">-->
<!--        <el-form-item  label-width="140px"  class="hang" label="举办者" prop="organizer">-->
<!--          <el-input class="inputs" v-model="form.organizer" @input="inputnow"/>-->
<!--          <span class="xing">*</span><span class="bei">请输入举办者真实姓名</span>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
<!--      <el-col :span="24">-->
<!--        <el-form-item  label-width="140px"  class="hang" label="身份证号码" prop="organizerIdCard">-->
<!--          <el-input class="inputs" v-model="form.organizerIdCard" @input="inputnow"/>-->
<!--          <span class="xing">*</span><span class="bei">请输入举办者身份证号码</span>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
<!--      <el-col :span="24">-->
<!--        <el-form-item  label-width="140px"  class="hang" label="手机号码" prop="phone">-->
<!--          <el-input class="inputs" v-model="form.phone" @input="inputnow"/>-->
<!--          <span class="xing">*</span><span class="bei">请输入举办者手机号码</span>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
<!--      <el-col :span="24">-->
<!--        <el-form-item  label-width="140px"  class="hang" label="图形验证码" prop="code">-->
<!--          <el-input class="inputs" style="width: 25%" v-model="iconv" @input="inputnow"/>-->
<!--          <img :src="this.baseUrl" class="buttons"/>-->
<!--          <span class="xing">*</span><span class="bei">请输入图形验证码</span>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
<!--      <el-col :span="24">-->
<!--        <el-form-item  label-width="140px"  class="hang" label="验证码" prop="code">-->
<!--          <el-input class="inputs" style="width: 25%" v-model="form.code" @input="inputnow"/>-->
<!--          <div class="buttons">获取短信验证码</div>-->
<!--          <span class="xing">*</span><span class="bei">请输入短信验证码</span>-->
<!--        </el-form-item>-->
<!--      </el-col>-->
      <div style="margin-top: 20px;margin-bottom: 20px;">
        <img class="img " src="@/images/biaodan/u113.png">
      </div>
      <div class="buttons2" size="mini" @click="jichutijiao">查询</div>
    </el-row>
  </el-form>


  <!-- Unnamed (矩形) -->
  <div id="u58" class="ax_default label">
    <div id="u58_div" class=""></div>
    <div id="u58_text" class="text ">
      <p style="text-align:center;"><span>河北省体育局版权所有 主办：河北省体育局 </span></p>
      <p style="text-align:center;"><span>地址：河北省石家庄市中山东路372号 邮编：050011 邮箱：hebeitiyuju@163.com </span></p>
      <p style="text-align:center;"><span>网站运维电话：0311-85266259 冀ICP备：2022017224号 冀公网安备：13010202002305号 </span></p>
    </div>
  </div>
</template>

<script>
import {ElMessage} from "element-plus";
export default {
  name: 'BaoBei',
  data() {
    return {
      baseUrl: '',//图形验证码
      icon: 0,
      iconv: '',
      form: {
        "companyName": "",
        "organizer": "",
        "organizerIdCard": "",
        "phone": "",
        "code": ''
      },
    }
  },
  created() {
  },
  methods: {
    inputnow() {
      localStorage.setItem('jindu', JSON.stringify(this.form))
    },
    jichutijiao(){
      // filing_progress_query(this.form).then(res=>{
      //   console.log(res)
      //   if(!res.data){
      //     ElMessage.error(res.header.msg)
      //   }
      //   if(res.data){
      //     localStorage.setItem('cxjg',JSON.stringify(res.data))
      //     this.$router.push('/jieguo')
      //   }
      // })
      ElMessage.success('尚未找到该机构信息')

    }


  }
}
</script>
<style scoped>

#u58 {
  margin-top: 40px;
  background: rgb(242, 242, 242);
  height: 120px;
  padding: 10px 0;
  font-size: 16px;
}

#u51_img {
  width: 1000px;
}

#u52_img {
  border-width: 0px;
  position: absolute;
  left: 32px;
  top: 62px;
  width: 342px;
  height: 76px;
}

.jindu {
  margin-top: 20px;
  display: flex;
  margin-left: 100px;
}

.jindu .p1 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #CCCCCC;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span1 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #CCCCCC;
}

.jindu .p2 {
  width: 30px;
  height: 30px;
  border-radius: 100px;
  background: #FF0000;
  color: white;
  text-align: center;
  line-height: 30px;
  margin: 0 auto;
}

.jindu .span2 {
  width: 96px;
  text-align: center;
  font-size: 14px;
  color: #FF0000;
}


.imgx {
  margin-left: -25px;
}

.jindu div {
  margin-left: 20px;
}

.hang {
  margin-left: 150px;
  color: black;
  font-size: 16px;
}

.inputs {
  width: 40%;
  margin-left: 10px;
}

.selects {
  width: 40%;
  margin-left: 10px;
}

.xing {
  color: red;
  font-size: 18px;
  margin-left: 5px;
}

.bei {
  font-size: 16px;
  margin-left: 30px;
  color: #c9c9c9;
}


.el-form-item label {
  color: black;
  font-size: 16px;
}

.buttons {
  cursor: pointer;
  border-width: 0px;
  width: 15%;
  height: 30px;
  background: inherit;
  background-color: rgba(255, 102, 51, 1);
  border: none;
  border-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
}

.buttons1 {
  cursor: pointer;
  border-width: 0px;
  width: 40px;
  text-align: center;
  height: 30px;
  background: inherit;
  background-color: #409eff;
  border: none;
  border-radius: 3px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
}

.buttons2 {
  cursor: pointer;
  position: relative;
  left: 37%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 51, 51, 1);
  border: none;
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  text-align: center;
  line-height: 45px;
}

.buttons3 {
  cursor: pointer;
  position: relative;
  left: 20%;
  width: 190px;
  height: 45px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(255, 51, 51, 1);
  border-radius: 3px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FF3333;
}


</style>
